export { NO_IMAGE, getCurrentUser, fullName, formatChatTime } from '../groups/groupUtils';

export const getMessageText = (chat) => {
  if (typeof chat === 'string') return chat;
  return chat?.message || chat?.user_message || chat?.ai_message || '';
};

// The reply/reaction payload shape has varied across backend responses, so
// each getter checks several plausible field names rather than trusting one.
export const getReplyMessageData = (chat, chatsList = []) => {
  if (!chat) return null;

  const nested = chat?.reply_to || chat?.reply_chat || chat?.parent_chat || null;
  const fallbackId = chat?.reply_to_id || chat?.reply_chat_id;

  if (fallbackId && Array.isArray(chatsList)) {
    const replied = chatsList.find((c) => Number(c?.id) === Number(fallbackId));
    if (replied) {
      return {
        id: replied.id,
        message: getMessageText(replied),
        senderName: fullNameOrUser(replied?.sender),
      };
    }
  }

  if (!nested) return null;

  return {
    id: nested?.id || fallbackId,
    message: getMessageText(nested),
    senderName: nested?.sender_name || fullNameOrUser(nested?.sender || nested?.user),
  };
};

function fullNameOrUser(user) {
  const name = [user?.first_name, user?.last_name].filter(Boolean).join(' ');
  return name || 'User';
}

export const REACTION_OPTIONS = [
  { type: 'like', emoji: '\u{1F44D}', label: 'Like' },
  { type: 'love', emoji: '\u{2764}\u{FE0F}', label: 'Love' },
  { type: 'laugh', emoji: '\u{1F602}', label: 'Laugh' },
  { type: 'wow', emoji: '\u{1F62E}', label: 'Wow' },
  { type: 'sad', emoji: '\u{1F622}', label: 'Sad' },
];

const getReactionEmoji = (value) => {
  const normalized = (value || '').toLowerCase();
  if (!normalized) return '';
  const match = REACTION_OPTIONS.find(
    (r) => r.type === normalized || r.label.toLowerCase() === normalized || r.emoji === value,
  );
  return match?.emoji || value;
};

export const getReactionSummary = (chat) => {
  if (!chat) return null;

  const list = chat?.reactions || chat?.chat_reactions || chat?.user_chat_reactions || [];
  if (Array.isArray(list) && list.length > 0) {
    const counts = list.reduce((acc, r) => {
      const value = getReactionEmoji(r?.reaction || r?.emoji || r?.type || '');
      if (!value) return acc;
      acc[value] = (acc[value] || 0) + 1;
      return acc;
    }, {});
    const entries = Object.entries(counts);
    if (entries.length > 0) {
      const [emoji] = entries.sort((a, b) => b[1] - a[1])[0];
      const total = entries.reduce((sum, [, c]) => sum + c, 0);
      return { emoji, count: total };
    }
  }

  if (chat?.reaction) {
    return { emoji: getReactionEmoji(chat.reaction), count: 1 };
  }

  return null;
};
